import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

export interface InventoryOpeningBalanceState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allOpeningBalanceList: any[];
}

const initialState: InventoryOpeningBalanceState = {
  data: null,
  currentPage: null,
  totalRecords: null,
  totalPages: null,
  allOpeningBalanceList: [],
};

export const inventoryOpeningBalanceSlice = createSlice({
  name: "inventoryOpeningBalance",
  initialState,
  reducers: {
    setInventoryOpeningBalance: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setInventoryOpeningBalanceBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setInventoryOpeningBalanceList: (state, action) => {
      state.allOpeningBalanceList = action.payload.data;
    },
    reset: () => initialState,
  },
});

export const {
  setInventoryOpeningBalance,
  setInventoryOpeningBalanceBySearch,
  setInventoryOpeningBalanceList,
  reset,
} = inventoryOpeningBalanceSlice.actions;

export const getInventoryOpeningBalanceDetails = (state: RootState) =>
  state.inventoryOpeningBalance.data;
export const getInventoryOpeningBalanceTotalRecords = (state: RootState) =>
  state.inventoryOpeningBalance.totalRecords;
export const getInventoryOpeningBalanceSearch = (state: RootState) =>
  state.inventoryOpeningBalance.data;
export const getInventoryOpeningBalanceList = (state: RootState) =>
  state.inventoryOpeningBalance.allOpeningBalanceList;

export default inventoryOpeningBalanceSlice.reducer;
